/* TODO: t() */
import React, { Component } from 'react';
import cx from 'classnames';
import autobind from 'class-autobind';

type Props = {
  className?: string;
};

class LoadingIndicator extends Component<Props> {
  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  render() {
    let className = cx(this.props.className, {
      'loading-indicator': true,
      'no-delay': true,
    });
    return (
      <span className={className}>
        <hr />
        <hr />
        <hr />
      </span>
    );
  }
}

export default LoadingIndicator;
